<template>
  <van-field class="uploader-business" name="uploader" :label="label">
    <template #input>
      <van-uploader :max-count="1" :after-read="afterRead" v-model="business" />
    </template>
  </van-field>
</template>

<script>
// import { Toast } from "vant";
import moment from "moment";
import getUpToken from "@/api/getUpToken";
import axios from "axios";
export default {
  props: ["label", "meth"],
  data() {
    return {
      business: []
    };
  },
  methods: {
     deleter(){
      this.business=[]
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      return new Promise((resolve, reject) => {
        let splitArray = file.file.name.split(".");
        let current = moment()
            .format("YYYYMMDD")
            .toString(),
          prefix = moment(file.file.lastModified)
            .format("HHmmss")
            .toString(),
          suffix =
            new Date().getTime() + "." + splitArray[splitArray.length - 1],
          key = encodeURI(`${current}/${prefix}_${suffix}`);
        getUpToken({ key })
          .then(res => {
            file.status = "done";
            file.message = "上传成功...";
            let data = new FormData();
            data.append("token", res.data.uptoken);
            data.append("key", key);
            data.append("file", file.file);
            axios({
              url: "//upload.qiniup.com",
              method: "POST",
              data: data,
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
              .then(res => {
                this.$emit("business", res.data.domain + res.data.truekey);
                this.$emit("licences", res.data.domain + res.data.truekey);
                this.$emit("Businesse", res.data.domain + res.data.truekey);
              })
              .catch(err => {
                reject(err);
                file.status = "failed";
                file.message = "上传失败";
              });
          })
          .catch(error => {
            file.status = "failed";
            file.message = "上传失败";
            reject(error);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>